export enum NotifyEmail {
	HARDSHIP = 'info@arlcollect.com.au',
	COMPLAINT = 'complaints@arlcollect.com.au',
}
